<template>
    <span>
        <div v-for="s in sections" class="info-section alt-color-rev">
            <div class="main" v-html="s">
            </div>
        </div>
    </span>
</template>

<script>
    export default {
        props: [
            'text',
            'props'
        ],
        data() {
            return {
            };
        },
        computed: {
            sections() {
                let t = this.text;

                t = _.replace(this.text, /<li>/ig, '<li> <i class="fg-color icon-chevron-circle-right"></i>');

                let images = []; // TODO: fix
                if(this.props.job.landing_page_template.images) {
                    images = this.props.job.landing_page_template.images;
                }

                t = this.insertImages(t, images);
                let result = _.split(t, '<hr>');
                return result;
            }
        },
        methods: {
            insertImages(text, images) {
                text = _.replace(text, /<\/ +ul>/ig, '</ul>');

                let before = `<div class="list-area-cover">
                                <div class="list-area-info">
                                    <div class="list-area-image">
                                        <img src="%%image%%">
                                    </div>`;
                let after = `</div></div>`;

                // getting <ul></ul>
                let matches = [];
                let regex = /(<ul.*?>)|(<\/ul>)/gi;
                let result = null;

                while (result = regex.exec(text)) {
                    matches.push({
                        start: result.index,
                        open: result[0].startsWith('<ul')
                    });
                }

                // collect all <ul></ul>
                let uls = [];
                let ulsLevel = 0;
                for (let i=0; i<matches.length; ++i) {
                    if (ulsLevel === 0)
                        uls.push(matches[i]);

                    ulsLevel += matches[i].open ? 1 : -1;

                    if (ulsLevel === 0)
                        uls.push(matches[i]);
                }

                // convert to just the 1st level of <ul></ul> - remove nested lists
                let splices = [];
                for (let i=0; i<uls.length; i+=2) {
                    splices.push({
                        from: uls[i].start,
                        to: uls[i+1].start + 5,
                        text: text.substring(uls[i].start, uls[i+1].start + 5)
                    })
                }

                // replace the text
                for (let i=0; i<splices.length && i<10 && i < images.length; ++i) {
                    let beforeWithImage = before.replace('%%image%%', images[i].url);
                    text = text.replace(splices[i].text, beforeWithImage + splices[i].text + after);
                }
                return text;
            }
        }
    }
</script>
